import { render, staticRenderFns } from "./recurringTicketsTable.vue?vue&type=template&id=6864d252"
import script from "./recurringTicketsTable.vue?vue&type=script&lang=js"
export * from "./recurringTicketsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports